const genDefaultToggles = (environmentName) => ({
  checkout_isBopusEnabled: true,
  sitewide_isContentfulEnabled: true,
  showFreeShippingLabel: false,
  isSkipCartEnabled: false,
  isLoggingEnabled: true,
  isExtendWarrantyEnabled: true,
  isLoyaltyProgramEnabled: false,
})
const manualEnvironmentOverrides = {
  local: {},
  staging: {},
  production: {
    isLoggingEnabled: false,
    checkout_isBopusEnabled: Date.now() < new Date('2021-01-29T19:00:00.000-08:00') // ON if before 7:00PM PST on Jan. 29th
      || Date.now() > new Date('2021-02-01T00:00:00.000-08:00'), // ON if after 12AM PST on Feb. 1
  },
}

const setFeatureToggles = (environmentName) => (
  { ...genDefaultToggles(environmentName), ...manualEnvironmentOverrides[environmentName] }
)

module.exports = setFeatureToggles
